<template>
	<ul>
		<li v-for="item in data" :key="item.id" @click="toService(item)">
			<van-image class="bg" :src="item.background_image || defaultImg" alt="" />
			<div class="info">
				<p class="nickname">
					{{ item.name }}
				</p>
				<p class="desc">{{ item.detail }}</p>
				<div class="price-box">
					<div class="price">
						<img src="~/assets/images/pc/coin.png" alt="" />
						<span class="price-text">{{ item.final_price }}</span>
					</div>
					<div
						class="btn"
						v-show="teacherInfo?.big_teacher_assistant_str != 0"
						@click.stop="toChat"
					>
						免費提問
					</div>
				</div>
			</div>
		</li>
	</ul>
</template>

<script setup>
import defaultImg from "~/assets/images/default.png";
import { inject } from "vue";
import { logEvent } from "~/utils/firebase";

const openLogin = inject("openLogin");
const props = defineProps({
	data: {
		type: Array,
		default: () => [],
	},
	teacherId: {
		type: String,
		default: "",
	},
	teacherInfo: {
		type: Object,
		default: () => ({}),
	},
	chatEvent: {
		type: String,
		default: "",
	},
});

const toService = item => {
	// 使用 Nuxt 路由跳转
	navigateTo(`/seer/teacher-service/${props.teacherId}/${item.id}`);
};
const toChat = () => {
	// 客户端环境执行
	if (import.meta.client) {
		logEvent(props.chatEvent);
	}
	openLogin();
	// 使用 Nuxt 路由跳转
	navigateTo(`/seer/chat/${props.teacherInfo.big_teacher_assistant_str}`);
};
</script>

<style lang="scss" scoped>
ul {
	padding: 32px 32px 0;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	font-family: PingFang SC;

	li {
		width: calc(50% - 8px);
		margin-bottom: 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #ffffff;
		border-radius: 8px;
		cursor: pointer;
		overflow: hidden;

		&:nth-last-child(1),
		&:nth-last-child(2) {
			margin-bottom: 0;
		}

		&:nth-child(2n) {
			margin-right: 0;
		}

		.bg {
			width: 334px;
			height: 334px;
			object-fit: cover;
		}

		.info {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 16px;

			.nickname {
				width: 100%;
				font-weight: 500;
				font-size: 32px;
				color: #2b2f36;
				line-height: 38px;
			}

			.desc {
				margin-top: 8px;
				margin-bottom: 24px;
				font-size: 26px;
				color: #646a73;
				line-height: 34px;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.price-box {
				width: 304px;
				margin-top: auto;
				display: flex;
				align-items: center;
				justify-content: space-between;
				color: #83570e;

				.price {
					display: flex;
					align-items: flex-end;

					img {
						margin-right: 4px;
						width: 34px;
						height: 34px;
					}

					.price-text {
						font-family: DIN Alternate;
						font-weight: bold;
						font-size: 36px;
						color: #83570e;
						line-height: 34px;
					}
				}

				.btn {
					padding: 6px 16px;
					font-weight: 500;
					font-size: 24px;
					color: #ffffff;
					line-height: 37px;
					text-align: center;
					background: linear-gradient(78deg, #da9b60 0%, #bb712d 100%);
					border-radius: 4px 4px 4px 4px;
				}
			}
		}
	}
}
</style>
